<div [formGroup]="form"
     class="flex-col gap-16">
    <div class="flex-col gap-8">
        <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="name">
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.AI.PROMT'|translate }} <span class="required">*</span></label>
        <textarea formControlName="promt"
                  class="ui-input ui-input-40">
        </textarea>
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.AI.MODEL'|translate }} <span class="required">*</span></label>

        <mat-select class="ui-selector ui-selector-40"
                    formControlName="model">
            @for(modelKey of modelKeys; track modelKey) {
            <mat-option [value]="modelKey">{{modelsMap[modelKey]}}</mat-option>
            }
        </mat-select>
    </div>

</div>